module.exports = __webpack_public_path__ + "static/media/S4N2-2.0820d6ac.svg";